export class LocationSchema {
    id: string;
    locationId: string;
    productionLines: ProductionLine[];
}

export class ProductionLine {
    id: string;
    name: string;
    workCells: WorkCell[];
}

export class WorkCell {
    id: string;
    name: string;
    thingIds: string[];
}